var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"id":"header"}},[(_vm.isLoggedIn && _vm.$route.meta.header.type !== 'light')?_c('AuthenticatedHeader'):_c('PublicHeader')],1)}
var staticRenderFns = []

export { render, staticRenderFns }